const SET_ENRICHMENT_LOGS_FILTERS = 'SET_ENRICHMENT_LOGS_FILTERS';
export const setEnrichmentLogsFilters = (filters: EnrichmentLogsFiltersProp) => ({
  type: SET_ENRICHMENT_LOGS_FILTERS,
  payload: filters,
});

export interface EnrichmentLogsFiltersProp {
  [key: string]: any;
}

const initialState: EnrichmentLogsFiltersProp = {};

interface Action {
  type: string;
  payload: EnrichmentLogsFiltersProp;
}

export const enrichmentLogsFiltersReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_ENRICHMENT_LOGS_FILTERS:
      return { ...action.payload };

    default:
      return state;
  }
};
